import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'bb-footer-mobile {{if this.isOpen \"is-open\"}}\' ...attributes>\n  <button\n    type=\'button\'\n    class=\'button success bb-footer-mobile-save {{if @saveRunning \"loading\"}}\'\n    disabled={{@saveRunning}}\n    data-test-run-save\n    {{on \'click\' this.runSave}}\n    {{on-key \'ctrl+s\'}}\n  >\n    <span>\n      {{#if @saveLabel}}\n        {{@saveLabel}}\n      {{else}}\n        {{t \'save\'}}\n      {{/if}}\n    </span>\n  </button>\n\n  {{#if this.hasMenu}}\n    <button\n      type=\'button\'\n      class=\'button bb-footer-mobile-toggle\'\n      aria-haspopup=\'menu\'\n      aria-expanded=\'{{if this.isOpen \"true\" \"false\"}}\'\n      aria-label={{t \'actions\'}}\n      data-test-bb-footer-mobile-toggle\n      {{on \'click\' this.toggle}}\n    >\n      <FaIcon @icon=\'ellipsis-vertical\' />\n    </button>\n\n    {{#if this.isOpen}}\n      <button\n        type=\'button\'\n        class=\'save-menu-backdrop\'\n        aria-hidden=\'true\'\n        tabindex=\'-1\'\n        data-test-bb-footer-mobile-close\n        {{on \'click\' this.close}}\n        {{on-key \'Escape\'}}\n      ></button>\n      <div class=\'save-menu-pane bb-footer-mobile-pane\' role=\'menu\'>\n        {{#each this.extraActions as |a|}}\n          <button\n            type=\'button\'\n            class=\'save-menu-item\'\n            role=\'menuitem\'\n            disabled={{a.running}}\n            data-test-run-extra\n            {{on \'click\' (fn this.runExtra a.action)}}\n          >\n            {{a.label}}\n          </button>\n        {{/each}}\n\n        {{#if this.canArchiveElement}}\n          <button\n            type=\'button\'\n            class=\'save-menu-item\'\n            role=\'menuitem\'\n            data-test-archive\n            {{on \'click\' this.archive}}\n          >\n            {{if @item.archivied (t \'restore\') (t \'trashing\')}}\n          </button>\n        {{/if}}\n\n        {{#if this.canDeleteElement}}\n          <button\n            type=\'button\'\n            class=\'save-menu-item save-menu-item-danger\'\n            role=\'menuitem\'\n            data-test-delete\n            {{on \'click\' this.delete}}\n          >\n            {{t \'delete\'}}\n          </button>\n        {{/if}}\n      </div>\n    {{/if}}\n  {{/if}}\n</div>");

var _class, _descriptor, _descriptor2;
let BbFooterMobileComponent = (_class = class BbFooterMobileComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "isOpen", _descriptor2, this);
  }
  // Destructive actions only make sense on a persisted record, and callers
  // (e.g. invoice) may forbid them for certain states via @allowDestructive.
  get allowDestructive() {
    return (this.args.allowDestructive ?? true) && !!this.args.item?.id;
  }
  get canArchiveElement() {
    if (!this.allowDestructive) return false;
    const val = this.args.canArchiveElement ?? true;
    return val !== 'false' && val !== false;
  }
  get canDeleteElement() {
    if (!this.allowDestructive) return false;
    let modelName = this.args.item.constructor.modelName;
    if (modelName === 'invoice' && this.args.item.estimate) {
      modelName = 'estimate';
    }
    return this.session.me?.get?.(`role.${modelName}_delete`) ?? false;
  }
  get extraActions() {
    return this.args.extraActions ?? [];
  }
  get hasMenu() {
    return this.canDeleteElement || this.canArchiveElement || this.extraActions.length > 0;
  }
  toggle() {
    this.isOpen = !this.isOpen;
  }
  close() {
    this.isOpen = false;
  }
  runSave() {
    this.close();
    this.args.onSave?.();
  }
  runExtra(fn) {
    this.close();
    fn?.();
  }
  delete() {
    this.close();
    this.args.toggleRemove?.(true);
  }
  archive() {
    this.close();
    this.args.toggleRemove?.(false);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "runSave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "runSave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "runExtra", [action], Object.getOwnPropertyDescriptor(_class.prototype, "runExtra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [action], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "archive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "archive"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbFooterMobileComponent);

export { BbFooterMobileComponent as default };
//# sourceMappingURL=bb-footer-mobile.js.map
